export default __webpack_public_path__ + "fonts/MarsCentra-Extrabold.woff2";